import { useCallback, useState } from "react";
import { downloadPumpSizingPdf } from "../utils/pdf/downloadPumpSizingPdf";

export function usePumpSizingPdfDownload() {
	const [isPdfDownloading, setIsPdfDownloading] = useState<boolean>(false);
	const [pdfError, setPdfError] = useState<string>("");

	const downloadPdf = useCallback(async (savedResultId?: string) => {
		setPdfError("");
		setIsPdfDownloading(true);

		try {
			await downloadPumpSizingPdf(savedResultId);
		} catch (error) {
			const message =
				error instanceof Error
					? error.message
					: "PDF download failed. Please try again.";
			setPdfError(message);
		} finally {
			setIsPdfDownloading(false);
		}
	}, []);

	return {
		downloadPdf,
		isPdfDownloading,
		pdfError,
		clearPdfError: () => setPdfError(""),
	};
}
